import moment from 'moment';

import {MOMENT_FULL_DATE_FORMAT} from '../constants/uiConstants';

/**
 * Gets the fallback text to show when there is no upcoming renewal.
 *
 * @param {{subscriptionStatus: ?string, subscriptionEndsAt: ?string}} creditsRenewal
 * @returns {string}
 */
export function getNextRenewalFallbackText(creditsRenewal) {
  if (creditsRenewal.subscriptionStatus === 'non_renewing' && creditsRenewal.subscriptionEndsAt) {
    return `Plan ending on ${moment(creditsRenewal.subscriptionEndsAt).format(MOMENT_FULL_DATE_FORMAT)}`;
  }

  return 'N/A';
}

/**
 * Gets the renewal text to show in the credits tooltips.
 *
 * @param {{nextRenewalAt: ?string, subscriptionStatus: ?string, subscriptionEndsAt: ?string}} creditsRenewal
 * @returns {string}
 */
export function getNextRenewalText(creditsRenewal) {
  if (creditsRenewal.nextRenewalAt) {
    return `Next Renewal: ${moment(creditsRenewal.nextRenewalAt).format(MOMENT_FULL_DATE_FORMAT)}`;
  }

  return `Next Renewal: ${getNextRenewalFallbackText(creditsRenewal)}`;
}
